let observerIdCounter = 0;

export default {
  data: () => ({
    ruleObserverId: ++observerIdCounter,
  }),
  beforeUnmount() {
    this.unobserveAllRules();
  },
  methods: {
    observeRule(rule, options = {}) {
      this.$store.dispatch('rules/observeRule', {
        rule,
        observerId: this.ruleObserverId,
        options,
      });
    },
    unobserveRule(ruleId) {
      this.$store.dispatch('rules/unobserveRule', {
        ruleId,
        observerId: this.ruleObserverId,
      });
    },
    unobserveAllRules() {
      this.$store.dispatch('rules/unobserveAllRulesByObserver', this.ruleObserverId);
    },
  },
};
